import { css } from '@firebolt-dev/css'
import { useEffect, useRef, useState } from 'react'
import { Ranks } from '../../core/extras/ranks'

const KIOSK_POINTS = [
  { id: 1, x: 466.61, z: -423.43, label: '1' },
  { id: 2, x: 462.22, z: -413.34, label: '2' },
  { id: 3, x: 453.43, z: -393.17, label: '3' },
  { id: 4, x: 448.64, z: -382.17, label: '4' },
  { id: 5, x: 458.94, z: -378.78, label: '5' },
  { id: 6, x: 470.91, z: -381.20, label: '6' },
  { id: 7, x: 477.93, z: -392.32, label: '7' },
  { id: 8, x: 482.20, z: -404.64, label: '8' },
  { id: 9, x: 479.26, z: -417.92, label: '9' },
]

export const KAIFF_SECRET_AVATAR_URL =
  'asset://661a8ecd26c4167d5beeee17ca5e0f269a70a9452f3dc0b45c1bef7f6fe4ef9f.vrm'

export const AVATAR_ROSTER = [
  // Düşünürler & Şairler (3)
  { id: 'ulus_baker', group: 'Düşünürler & Şairler', label: '🎓 Ulus Baker', url: 'asset://4e6ec3d2fd96e4d7eb4d14a950929e8b1b0d98b2c9685e8a98b1fbc048d2f94b.vrm' },
  { id: 'pembe_marmara', group: 'Düşünürler & Şairler', label: '✒️ Pembe Marmara', url: 'asset://17144724b7f7ebf913eaaafe8420cc0ab22484e58d83f762099c6f22839b7acc.vrm' },
  { id: 'spinoza', group: 'Düşünürler & Şairler', label: '📜 Baruch Spinoza', url: 'asset://d6ca33e60514c086766d34ebba71ea6093e8dfc87be8404719c4d6f4afa001ac.vrm' },
  // Erkekler (8)
  { id: 'deniz', group: 'Erkekler', label: '👨 Erkek — Deniz', url: 'asset://794ed00ce5147243d5d4a5abb75fa9ba3d7f0a66d3f92837085e715955ad03d8.vrm' },
  { id: 'kerem', group: 'Erkekler', label: '👨 Erkek — Kerem', url: 'asset://d31d9e5edaa15cb00da61e7c7a7f415efffe1b8b658d29a0b84fd811da446b23.vrm' },
  { id: 'murat', group: 'Erkekler', label: '👨 Erkek — Murat', url: 'asset://97748c7a0ea4234cf6a2450d48c0c4cf9f23d702dd74a8ed4cec0bd02978494d.vrm' },
  { id: 'emre', group: 'Erkekler', label: '👨 Erkek — Emre', url: 'asset://6c4209043f9e5533038cd00a7f3df939eca79f04ea707e6d7a7dac6e25d06fad.vrm' },
  { id: 'bora', group: 'Erkekler', label: '👨 Erkek — Bora', url: 'asset://5cbebd5cf2e7e9133b42af0628e7410da82403a3133b79d71fa824dae8cf43cb.vrm' },
  { id: 'arda', group: 'Erkekler', label: '👨 Erkek — Arda', url: 'asset://51a78e3014be833643ee3d6b25814cdd0bda62c875b7ca8e4147ffea7edd5f3f.vrm' },
  { id: 'kaan', group: 'Erkekler', label: '👨 Erkek — Kaan', url: 'asset://4e872329741a9dde7ef33316297cb54da7d4431c373cdfdcd9263ded98df6b9f.vrm' },
  { id: 'eren', group: 'Erkekler', label: '👨 Erkek — Eren', url: 'asset://f2dc34e35b11255a7e233d8b6f9426310354557dadf7be948c46243d0d7fc812.vrm' },
  // Kadınlar (9)
  { id: 'selin', group: 'Kadınlar', label: '👩 Kadın — Selin', url: 'asset://798febb18c5a6211837f964da9bb2da0b112d03461469f902b372989fc3fafc2.vrm' },
  { id: 'elif', group: 'Kadınlar', label: '👩 Kadın — Elif', url: 'asset://51618f4d83ae8bf40591cd7457b251bb95d7ac3a621f515771cc9b781197e191.vrm' },
  { id: 'zeynep', group: 'Kadınlar', label: '👩 Kadın — Zeynep', url: 'asset://c93bd754079065cbe20ca66f3331c7686941cb7c71e5211dbd048af0c87df5a8.vrm' },
  { id: 'defne', group: 'Kadınlar', label: '👩 Kadın — Defne', url: 'asset://d4385ca3807e64026d369f45a090e0c7914922ce5d8f0ac33071173054b77559.vrm' },
  { id: 'leyla', group: 'Kadınlar', label: '👩 Kadın — Leyla', url: 'asset://0717d6631faacc8141884b8e2bd1f66d8199f20a97b14506d28c0038e55511ff.vrm' },
  { id: 'sino', group: 'Kadınlar', label: '👩 Kadın — Şino', url: 'asset://150bf66a68b79017b21eabe8e5dffc9fb9945f5db8d4de6ea2265b0b1e88127a.vrm' },
  { id: 'asli', group: 'Kadınlar', label: '👩 Kadın — Aslı', url: 'asset://1ceb7906b6160fee4ac9727878e77d2eaac573986a0b3536edb1e51589574871.vrm' },
  { id: 'nilufer', group: 'Kadınlar', label: '👩 Kadın — Nilüfer', url: 'asset://cf2d2424515a87528b422cf731eaf3cd804e93c1805b1adce10a922554994d0f.vrm' },
  { id: 'yasemin', group: 'Kadınlar', label: '👩 Kadın — Yasemin', url: 'asset://7ae242ee4a1721c1ed2587adcf6225f1355239e35e0d175ae459674bbb0a3925.vrm' },
]

const PEMBE_SIGN_POS = { x: 454.8, z: -395.8 }
const HOUSE72_BOX = { minX: 456.62, maxX: 461.41, minZ: -408.24, maxZ: -397.24 }
const HOUSE74_BOX = { minX: 461.41, maxX: 465.80, minZ: -418.33, maxZ: -408.24 }

// World bounds baked into /arabahmet_minimap_r2.png (2048x2048)
const MAP_MIN_X = -1120.0
const MAP_MAX_X = 1580.0
const MAP_MIN_Z = -1715.0
const MAP_MAX_Z = 985.0
const MAP_TEX_SIZE = 2048

// World <-> lat/lon, same projection as tools\arabahmet_build_r4.py (Blender +Y north = world -Z)
const LAT0 = 35.1773
const LON0 = 33.3584
const KX = Math.cos((LAT0 * Math.PI) / 180) * 111320.0
const KY = 110574.0
const worldToLatLon = (x, z) => ({ lat: LAT0 - z / KY, lon: LON0 + x / KX })

// Enlarged minimap shows the whole r4 OSM area (x -1074..1519, z -1028..299), filling a 2:1 panel
const DISTRICT_CENTER = { x: 223.0, z: -365.0 }
const DISTRICT_SPAN_X = 2620.0
const MAP_SIZE_LOCAL = { w: 210, h: 210 }
const MAP_SIZE_DISTRICT = { w: 420, h: 215 }

// Camera clip planes per mode: a far-off near plane keeps depth precision high from the air,
// which stops coplanar roofs and roads flickering in the aerial views
const CLIP_BY_MODE = {
  walk: { near: 0.2, far: 1200 },
  fly: { near: 1.0, far: 1500 },
  plaza: { near: 1.0, far: 1500 },
  fullmap: { near: 4.0, far: 3500 },
}
const GMAPS_ZOOM_BY_MODE = { walk: 19, fly: 18, plaza: 18, fullmap: 16 }

export function MinimapAndAerialUI({ world }) {
  const canvasRef = useRef(null)
  const mapImgRef = useRef(null)
  const [camMode, setCamMode] = useState('walk') // 'walk' | 'fly' | 'plaza' | 'fullmap'
  const [mapZoom, setMapZoom] = useState('local') // 'local' (115m) | 'district' (2400m)
  const [showWardrobe, setShowWardrobe] = useState(false)
  const [secretToast, setSecretToast] = useState(null)
  const [activeAvatarUrl, setActiveAvatarUrl] = useState(() => {
    const p = world?.entities?.player
    return p?.data?.sessionAvatar || p?.data?.avatar || ''
  })
  const camModeRef = useRef('walk')
  const mapZoomRef = useRef('local')
  const secretBufferRef = useRef('')
  const fullmapStateRef = useRef({
    panX: 0,
    panZ: 0,
    height: 310.0,
    mouseYaw: 0,
    mousePitch: 0,
    keys: {},
  })
  // Point on the ground the view is centred on (player in street mode, look-at point from the air)
  const viewTargetRef = useRef({ x: 455.3, z: -404.3 })
  const gmapsCoordsRef = useRef(null)
  const gmapsLinkRef = useRef(null)

  // Host = a player whose stored rank is ADMIN (entered the admin code), not the
  // everyone-is-admin fallback that applies while no ADMIN_CODE is set
  const [isHost, setIsHost] = useState(false)
  const isHostRef = useRef(false)
  const [kickArmed, setKickArmed] = useState(false)
  const kickTimerRef = useRef(null)
  const kickAllVisitors = () => {
    if (!kickArmed) {
      setKickArmed(true)
      clearTimeout(kickTimerRef.current)
      kickTimerRef.current = setTimeout(() => setKickArmed(false), 3000)
      return
    }
    clearTimeout(kickTimerRef.current)
    setKickArmed(false)
    world.network.send('command', { args: ['kickall'] })
  }

  const buildGmapsUrl = () => {
    const { x, z } = viewTargetRef.current
    const { lat, lon } = worldToLatLon(x, z)
    const zoom = GMAPS_ZOOM_BY_MODE[camModeRef.current] || 18
    return `https://www.google.com/maps/@?api=1&map_action=map&center=${lat.toFixed(6)},${lon.toFixed(6)}&zoom=${zoom}`
  }

  useEffect(() => {
    const img = new Image()
    img.src = '/arabahmet_minimap_r2.png'
    img.onload = () => {
      mapImgRef.current = img
    }
  }, [])

  useEffect(() => {
    camModeRef.current = camMode
  }, [camMode])

  useEffect(() => {
    mapZoomRef.current = mapZoom
  }, [mapZoom])

  const selectAvatar = item => {
    const player = world?.entities?.player
    if (!player) return
    player.setSessionAvatar(item.url)
    setActiveAvatarUrl(item.url)
  }

  const activateKaiffAvatar = () => {
    const player = world?.entities?.player
    if (!player) return
    player.setSessionAvatar(KAIFF_SECRET_AVATAR_URL)
    player.setName?.('Kaiff')
    setActiveAvatarUrl(KAIFF_SECRET_AVATAR_URL)
    setSecretToast('🕶️ Özel Avatar Aktif: Kaiff')
    setTimeout(() => setSecretToast(null), 3500)
  }

  const applyCamMode = mode => {
    setCamMode(mode)
    camModeRef.current = mode
    if (mode === 'fullmap') {
      fullmapStateRef.current.panX = 0
      fullmapStateRef.current.panZ = 0
      fullmapStateRef.current.height = 310.0
    }
    const player = world?.entities?.player
    if (!player?.control?.camera) return
    if (document.pointerLockElement) {
      document.exitPointerLock?.()
    }
    if (mode === 'walk') {
      player.control.camera.write = true
      world.camera.position.set(0, 0, 0)
      world.camera.rotation.set(0, 0, 0)
    } else {
      player.control.camera.write = false
    }
  }

  // Keyboard shortcuts & interactive fullmap camera controls:
  // - Shift + Alt + K (or typing "kaiff"): equips secret Kaiff avatar
  // - V: cycles camera views, M: toggles minimap zoom, C: toggles avatar selector
  // - In fullmap mode: WASD / Arrow keys pan, mouse move adds gentle look wiggle, wheel adjusts height
  useEffect(() => {
    const onKeyDown = e => {
      if (e.target && (e.target.tagName === 'INPUT' || e.target.tagName === 'TEXTAREA')) return
      fullmapStateRef.current.keys[e.code] = true
      if (e.shiftKey && e.altKey && e.code === 'KeyK') {
        e.preventDefault()
        activateKaiffAvatar()
        return
      }
      if (e.key && e.key.length === 1 && !e.ctrlKey && !e.metaKey) {
        secretBufferRef.current = (secretBufferRef.current + e.key.toLowerCase()).slice(-5)
        if (secretBufferRef.current === 'kaiff') {
          secretBufferRef.current = ''
          activateKaiffAvatar()
          return
        }
      }
      if (e.code === 'KeyV') {
        const order = ['walk', 'fly', 'plaza', 'fullmap']
        const next = order[(order.indexOf(camModeRef.current) + 1) % order.length]
        applyCamMode(next)
      } else if (e.code === 'KeyM') {
        setMapZoom(z => (z === 'local' ? 'district' : 'local'))
      } else if (e.code === 'KeyC') {
        if (document.pointerLockElement) document.exitPointerLock?.()
        setShowWardrobe(s => !s)
      }
    }
    const onKeyUp = e => {
      fullmapStateRef.current.keys[e.code] = false
    }
    const onMouseMove = e => {
      if (camModeRef.current !== 'fullmap') return
      const nx = (e.clientX / Math.max(1, window.innerWidth) - 0.5) * 2.0
      const ny = (e.clientY / Math.max(1, window.innerHeight) - 0.5) * 2.0
      fullmapStateRef.current.mouseYaw = -nx * 0.14
      fullmapStateRef.current.mousePitch = -ny * 0.09
    }
    const onWheel = e => {
      if (camModeRef.current !== 'fullmap') return
      const nextH = fullmapStateRef.current.height + e.deltaY * 0.18
      fullmapStateRef.current.height = Math.max(120.0, Math.min(560.0, nextH))
    }
    window.addEventListener('keydown', onKeyDown)
    window.addEventListener('keyup', onKeyUp)
    window.addEventListener('mousemove', onMouseMove)
    window.addEventListener('wheel', onWheel, { passive: true })
    return () => {
      window.removeEventListener('keydown', onKeyDown)
      window.removeEventListener('keyup', onKeyUp)
      window.removeEventListener('mousemove', onMouseMove)
      window.removeEventListener('wheel', onWheel)
    }
  }, [world])

  useEffect(() => {
    let animId
    const startTime = performance.now()
    let lastTime = startTime

    const tick = now => {
      animId = requestAnimationFrame(tick)
      const dt = Math.min(0.1, (now - lastTime) * 0.001)
      lastTime = now
      const player = world?.entities?.player
      if (!player) return

      const px = player.base.position.x
      const py = player.base.position.y
      const pz = player.base.position.z

      const host = (player.data?.rank ?? 0) >= Ranks.ADMIN && !!world.settings?.hasAdminCode
      if (host !== isHostRef.current) {
        isHostRef.current = host
        setIsHost(host)
      }

      // 1. Update Aerial / Static Camera if active
      const mode = camModeRef.current
      if (mode !== 'walk' && player.control?.camera) {
        player.control.camera.write = false
        world.camera.position.set(0, 0, 0)
        world.camera.rotation.set(0, 0, 0)
        world.rig.rotation.reorder('YXZ')

        if (mode === 'fly') {
          const t = (now - startTime) * 0.00032
          const cx = 463.0
          const cz = -398.0
          const radius = 38.0
          const camX = cx + Math.cos(t) * radius
          const camZ = cz + Math.sin(t) * radius
          const camY = 26.0 + Math.sin(t * 2.0) * 3.0
          world.rig.position.set(camX, camY, camZ)
          const dx = cx - camX
          const dz = cz - camZ
          const yaw = Math.atan2(-dx, -dz)
          const distXZ = Math.hypot(dx, dz)
          const pitch = -Math.atan2(camY - 2.0, distXZ)
          world.rig.rotation.set(pitch, yaw, 0)
        } else if (mode === 'plaza') {
          world.rig.position.set(436.0, 28.0, -366.0)
          world.rig.rotation.set(-0.58, -0.62, 0)
        } else if (mode === 'fullmap') {
          const fm = fullmapStateRef.current
          const panSpeed = 160.0 * dt
          if (fm.keys['KeyW'] || fm.keys['ArrowUp']) fm.panZ -= panSpeed
          if (fm.keys['KeyS'] || fm.keys['ArrowDown']) fm.panZ += panSpeed
          if (fm.keys['KeyA'] || fm.keys['ArrowLeft']) fm.panX -= panSpeed
          if (fm.keys['KeyD'] || fm.keys['ArrowRight']) fm.panX += panSpeed
          fm.panX = Math.max(-950.0, Math.min(950.0, fm.panX))
          fm.panZ = Math.max(-680.0, Math.min(680.0, fm.panZ))

          const ts = (now - startTime) * 0.001
          const swayX = Math.sin(ts * 0.28) * 18.0 + Math.cos(ts * 0.17) * 7.0
          const swayZ = Math.cos(ts * 0.23) * 16.0 + Math.sin(ts * 0.19) * 6.0
          const swayY = Math.sin(ts * 0.35) * 6.0
          const swayYaw = Math.sin(ts * 0.21) * 0.045
          const swayPitch = Math.cos(ts * 0.26) * 0.025

          const camX = 280.0 + fm.panX + swayX
          const camY = fm.height + swayY
          const camZ = 40.0 + fm.panZ + swayZ
          const pitch = -0.78 + swayPitch + fm.mousePitch
          const yaw = -0.08 + swayYaw + fm.mouseYaw
          world.rig.position.set(camX, camY, camZ)
          world.rig.rotation.set(pitch, yaw, 0)
        }
      }

      // 1b. Clip planes per mode (depth precision for the aerial views)
      const clip = CLIP_BY_MODE[mode] || CLIP_BY_MODE.walk
      if (world.camera.near !== clip.near || world.camera.far !== clip.far) {
        world.camera.near = clip.near
        world.camera.far = clip.far
        world.camera.updateProjectionMatrix()
      }

      // 1c. Ground point the view is centred on, for the Google Maps link (ground is y = 0)
      if (mode === 'walk') {
        viewTargetRef.current = { x: px, z: pz }
      } else {
        const pitch = world.rig.rotation.x
        const yaw = world.rig.rotation.y
        const dirY = Math.sin(pitch)
        if (dirY < -0.02) {
          const t = Math.min(4000, world.rig.position.y / -dirY)
          viewTargetRef.current = {
            x: world.rig.position.x - Math.sin(yaw) * Math.cos(pitch) * t,
            z: world.rig.position.z - Math.cos(yaw) * Math.cos(pitch) * t,
          }
        } else {
          viewTargetRef.current = { x: world.rig.position.x, z: world.rig.position.z }
        }
      }
      const coordsEl = gmapsCoordsRef.current
      if (coordsEl && Math.floor(now / 250) !== coordsEl._tick) {
        coordsEl._tick = Math.floor(now / 250)
        const { lat, lon } = worldToLatLon(viewTargetRef.current.x, viewTargetRef.current.z)
        coordsEl.textContent = `${lat.toFixed(5)}, ${lon.toFixed(5)}`
        // keep the link live too, so copy-link and middle-click get the current spot
        if (gmapsLinkRef.current) gmapsLinkRef.current.href = buildGmapsUrl()
      }

      // 2. Draw Minimap
      const canvas = canvasRef.current
      if (!canvas) return
      const ctx = canvas.getContext('2d')
      const W = canvas.width
      const H = canvas.height
      ctx.clearRect(0, 0, W, H)

      ctx.fillStyle = '#0b0f19'
      ctx.fillRect(0, 0, W, H)

      const zoom = mapZoomRef.current
      const centerX = zoom === 'local' ? px : DISTRICT_CENTER.x
      const centerZ = zoom === 'local' ? pz : DISTRICT_CENTER.z
      const spanX = zoom === 'local' ? 115.0 : DISTRICT_SPAN_X
      const scale = W / spanX
      const spanZ = H / scale   // the district panel is 2:1, so the whole area fills it

      const toScreen = (wx, wz) => [
        W * 0.5 + (wx - centerX) * scale,
        H * 0.5 + (wz - centerZ) * scale,
      ]

      // Draw pre-baked 2048x2048 wide district map image
      const mapImg = mapImgRef.current
      if (mapImg) {
        const minWX = centerX - spanX * 0.5
        const minWZ = centerZ - spanZ * 0.5
        const sx = ((minWX - MAP_MIN_X) / (MAP_MAX_X - MAP_MIN_X)) * MAP_TEX_SIZE
        const sy = ((minWZ - MAP_MIN_Z) / (MAP_MAX_Z - MAP_MIN_Z)) * MAP_TEX_SIZE
        const sw = (spanX / (MAP_MAX_X - MAP_MIN_X)) * MAP_TEX_SIZE
        const sh = (spanZ / (MAP_MAX_Z - MAP_MIN_Z)) * MAP_TEX_SIZE
        ctx.drawImage(mapImg, sx, sy, sw, sh, 0, 0, W, H)
      }

      // Draw AbdiCavus_74
      {
        const [x0, y0] = toScreen(HOUSE74_BOX.minX, HOUSE74_BOX.minZ)
        const [x1, y1] = toScreen(HOUSE74_BOX.maxX, HOUSE74_BOX.maxZ)
        ctx.fillStyle = '#cbd5e1'
        ctx.fillRect(x0, y0, Math.max(2, x1 - x0), Math.max(2, y1 - y0))
      }

      // Draw UB_house_72_candidate (Main House)
      {
        const [x0, y0] = toScreen(HOUSE72_BOX.minX, HOUSE72_BOX.minZ)
        const [x1, y1] = toScreen(HOUSE72_BOX.maxX, HOUSE72_BOX.maxZ)
        ctx.fillStyle = '#ea580c'
        ctx.strokeStyle = '#fbbf24'
        ctx.lineWidth = 1.5
        const rw = Math.max(4, x1 - x0)
        const rh = Math.max(4, y1 - y0)
        ctx.fillRect(x0, y0, rw, rh)
        ctx.strokeRect(x0, y0, rw, rh)
      }

      // Draw Pembe Marmara Heritage Panel marker
      {
        const [ux, uy] = toScreen(PEMBE_SIGN_POS.x, PEMBE_SIGN_POS.z)
        ctx.fillStyle = '#f472b6'
        ctx.beginPath()
        ctx.arc(ux, uy, zoom === 'local' ? 4.5 : 3.0, 0, Math.PI * 2)
        ctx.fill()
      }

      // Draw 9 Kiosks
      for (const k of KIOSK_POINTS) {
        const [kx, ky] = toScreen(k.x, k.z)
        const dist = Math.hypot(px - k.x, pz - k.z)
        const isPlaying = dist <= 2.4
        ctx.fillStyle = isPlaying ? '#4ade80' : '#f59e0b'
        ctx.beginPath()
        ctx.arc(kx, ky, zoom === 'local' ? (isPlaying ? 6 : 4.5) : 2.2, 0, Math.PI * 2)
        ctx.fill()
        if (zoom === 'local') {
          ctx.fillStyle = '#0b0f19'
          ctx.font = 'bold 8px sans-serif'
          ctx.textAlign = 'center'
          ctx.textBaseline = 'middle'
          ctx.fillText(k.label, kx, ky + 0.5)
        }
      }

      // Draw Player position & heading cone
      {
        const [sx, sy] = toScreen(px, pz)
        const rotY = world.rig.rotation.y || 0
        const dirX = -Math.sin(rotY)
        const dirZ = -Math.cos(rotY)
        const angle = Math.atan2(dirZ, dirX)

        ctx.fillStyle = 'rgba(56, 189, 248, 0.26)'
        ctx.beginPath()
        ctx.moveTo(sx, sy)
        ctx.arc(sx, sy, 18, angle - 0.45, angle + 0.45)
        ctx.closePath()
        ctx.fill()

        ctx.fillStyle = '#ffffff'
        ctx.strokeStyle = '#0284c7'
        ctx.lineWidth = 2
        ctx.beginPath()
        ctx.arc(sx, sy, 5, 0, Math.PI * 2)
        ctx.fill()
        ctx.stroke()
      }
    }

    animId = requestAnimationFrame(tick)
    return () => cancelAnimationFrame(animId)
  }, [world])

  const groups = ['Düşünürler & Şairler', 'Erkekler', 'Kadınlar']
  const mapSize = mapZoom === 'local' ? MAP_SIZE_LOCAL : MAP_SIZE_DISTRICT

  return (
    <div
      className='minimap-aerial-hud'
      onPointerDown={e => e.stopPropagation()}
      onClick={e => e.stopPropagation()}
      css={css`
        /* Layout (Kaiff, 2026-10-24): map + Google Maps link top-right;
           wardrobe, camera buttons and the host's kick button bottom-right */
        position: absolute;
        inset: 0;
        pointer-events: none;
        z-index: 20;
        font-family: 'Rubik', sans-serif;

        .hud-top,
        .hud-bottom {
          position: absolute;
          right: calc(1.25rem + env(safe-area-inset-right));
          display: flex;
          flex-direction: column;
          align-items: flex-end;
          gap: 0.5rem;
          pointer-events: auto;
        }
        .hud-top {
          top: calc(1.25rem + env(safe-area-inset-top));
        }
        .hud-bottom {
          bottom: calc(1.25rem + env(safe-area-inset-bottom));
        }

        .kick-btn {
          border: 1px solid rgba(248, 113, 113, 0.6);
          background: rgba(69, 10, 10, 0.88);
          color: #fecaca;
          font-size: 0.7rem;
          font-weight: 700;
          padding: 0.35rem 0.6rem;
          border-radius: 0.4rem;
          cursor: pointer;
          backdrop-filter: blur(6px);
          transition: all 0.15s ease;
        }
        .kick-btn:hover {
          background: rgba(127, 29, 29, 0.95);
          color: #ffffff;
        }
        .kick-btn.armed {
          background: #dc2626;
          border-color: #fca5a5;
          color: #ffffff;
        }

        .wardrobe-drawer {
          width: 340px;
          max-height: min(360px, calc(100vh - 26rem));
          overflow-y: auto;
          background: rgba(11, 15, 25, 0.95);
          border: 2px solid rgba(56, 189, 248, 0.7);
          border-radius: 0.75rem;
          padding: 0.65rem;
          box-shadow: 0 12px 32px rgba(0, 0, 0, 0.65);
          backdrop-filter: blur(8px);
          /* Scrollbar in the drawer's own palette instead of the browser default */
          scrollbar-width: thin;
          scrollbar-color: rgba(56, 189, 248, 0.6) rgba(15, 23, 42, 0.9);
        }
        .wardrobe-drawer::-webkit-scrollbar {
          width: 8px;
        }
        .wardrobe-drawer::-webkit-scrollbar-track {
          background: rgba(15, 23, 42, 0.9);
          border-radius: 0.5rem;
        }
        .wardrobe-drawer::-webkit-scrollbar-thumb {
          background: rgba(56, 189, 248, 0.6);
          border-radius: 0.5rem;
          border: 2px solid rgba(15, 23, 42, 0.9);
        }
        .wardrobe-drawer::-webkit-scrollbar-thumb:hover {
          background: #38bdf8;
        }

        .secret-toast {
          background: rgba(15, 23, 42, 0.94);
          border: 1.5px solid #f59e0b;
          color: #fbbf24;
          padding: 0.45rem 0.9rem;
          border-radius: 0.5rem;
          font-size: 0.78rem;
          font-weight: 700;
          box-shadow: 0 6px 20px rgba(0, 0, 0, 0.65);
        }

        .gmaps-row {
          display: flex;
          align-items: center;
          gap: 0.5rem;
          background: rgba(11, 15, 25, 0.88);
          border: 1px solid rgba(245, 158, 11, 0.45);
          border-radius: 0.5rem;
          padding: 0.25rem 0.55rem;
          font-size: 0.68rem;
          backdrop-filter: blur(6px);
        }
        .gmaps-link {
          color: #fbbf24;
          font-weight: 700;
          text-decoration: none;
        }
        .gmaps-link:hover {
          color: #ffffff;
          text-decoration: underline;
        }
        .gmaps-coords {
          color: #94a3b8;
          font-variant-numeric: tabular-nums;
        }

        .wardrobe-title {
          display: flex;
          justify-content: space-between;
          align-items: center;
          font-size: 0.78rem;
          font-weight: 700;
          color: #38bdf8;
          margin-bottom: 0.45rem;
          padding-bottom: 0.3rem;
          border-bottom: 1px solid rgba(56, 189, 248, 0.25);
        }

        .wardrobe-group {
          font-size: 0.65rem;
          font-weight: 700;
          color: #fbbf24;
          margin: 0.45rem 0 0.25rem;
          text-transform: uppercase;
        }

        .wardrobe-grid {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 0.3rem;
        }

        .av-btn {
          border: 1px solid rgba(148, 163, 184, 0.25);
          background: rgba(30, 41, 59, 0.85);
          color: #e2e8f0;
          font-size: 0.68rem;
          font-weight: 600;
          padding: 0.35rem 0.45rem;
          border-radius: 0.38rem;
          cursor: pointer;
          text-align: left;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          transition: all 0.12s ease;
        }
        .av-btn:hover {
          background: rgba(56, 189, 248, 0.25);
          border-color: #38bdf8;
          color: #ffffff;
        }
        .av-btn.selected {
          background: #0284c7;
          border-color: #38bdf8;
          color: #ffffff;
        }

        .cam-bar {
          display: flex;
          gap: 0.35rem;
          background: rgba(11, 15, 25, 0.88);
          border: 1px solid rgba(245, 158, 11, 0.45);
          border-radius: 0.6rem;
          padding: 0.3rem;
          backdrop-filter: blur(6px);
        }

        .cam-btn {
          border: 1px solid rgba(148, 163, 184, 0.25);
          background: rgba(30, 41, 59, 0.85);
          color: #e2e8f0;
          font-size: 0.72rem;
          font-weight: 600;
          padding: 0.35rem 0.55rem;
          border-radius: 0.4rem;
          cursor: pointer;
          transition: all 0.15s ease;
          white-space: nowrap;
        }
        .cam-btn:hover {
          background: rgba(51, 65, 85, 0.95);
          color: #ffffff;
        }
        .cam-btn.active {
          background: #f59e0b;
          color: #0b0f19;
          border-color: #fbbf24;
        }

        .minimap-box {
          position: relative;
          max-width: calc(100vw - 2.5rem);
          border-radius: 0.75rem;
          overflow: hidden;
          border: 2px solid rgba(245, 158, 11, 0.65);
          box-shadow: 0 8px 24px rgba(0, 0, 0, 0.55);
          background: rgba(11, 15, 25, 0.92);
          cursor: pointer;
          canvas {
            display: block;
            width: 100%;
            height: 100%;
          }
        }

        .minimap-header {
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 0.25rem 0.5rem;
          background: rgba(11, 15, 25, 0.78);
          font-size: 0.65rem;
          font-weight: 700;
          color: #fbbf24;
          border-bottom: 1px solid rgba(245, 158, 11, 0.25);
        }

        .minimap-legend {
          position: absolute;
          bottom: 0;
          left: 0;
          right: 0;
          display: flex;
          justify-content: space-between;
          padding: 0.2rem 0.45rem;
          background: rgba(11, 15, 25, 0.78);
          font-size: 0.6rem;
          color: #cbd5e1;
        }
      `}
    >
      <div className='hud-top'>
      <div
        className='minimap-box'
        style={{ width: mapSize.w, height: mapSize.h }}
        onClick={() => setMapZoom(z => (z === 'local' ? 'district' : 'local'))}
        title='Yakın / Tüm Harita geçişi için tıklayın (Kısayol: M)'
      >
        <canvas ref={canvasRef} width={mapSize.w} height={mapSize.h} />
        <div className='minimap-header'>
          <span>{mapZoom === 'local' ? 'MİNİ HARİTA (ABDI ÇAVUŞ)' : 'TÜM HARİTA (ARABAHMET)'}</span>
          <span style={{ color: '#94a3b8' }}>[{mapZoom === 'local' ? 'Büyüt: M' : 'Yakınlaş: M'}]</span>
        </div>
        <div className='minimap-legend'>
          <span style={{ color: '#ea580c' }}>■ Ev No.72</span>
          <span style={{ color: '#f59e0b' }}>● 1-9 Kiosk</span>
          <span style={{ color: '#ffffff' }}>● Siz</span>
        </div>
      </div>

      {/* Opens Google Maps at the ground point the view is centred on */}
      <div className='gmaps-row'>
        <a
          ref={gmapsLinkRef}
          className='gmaps-link'
          href={buildGmapsUrl()}
          target='_blank'
          rel='noopener noreferrer'
          onClick={e => {
            e.currentTarget.href = buildGmapsUrl()
          }}
          title="Baktığınız noktayı Google Maps'te açar"
        >
          📍 Google Maps'te aç
        </a>
        <span className='gmaps-coords' ref={gmapsCoordsRef} />
      </div>

      {secretToast && <div className='secret-toast'>{secretToast}</div>}
      </div>

      <div className='hud-bottom'>
      {showWardrobe && (
        <div className='wardrobe-drawer'>
          <div className='wardrobe-title'>
            <span>KARAKTER SEÇİMİ ({AVATAR_ROSTER.length} AVATAR)</span>
            <button
              className='cam-btn'
              style={{ padding: '0.15rem 0.4rem', fontSize: '0.65rem' }}
              onClick={() => setShowWardrobe(false)}
            >
              ✕ Kapat
            </button>
          </div>
          {groups.map(g => (
            <div key={g}>
              <div className='wardrobe-group'>{g}</div>
              <div className='wardrobe-grid'>
                {AVATAR_ROSTER.filter(a => a.group === g).map(item => (
                  <button
                    key={item.id}
                    className={`av-btn ${activeAvatarUrl === item.url ? 'selected' : ''}`}
                    onClick={() => selectAvatar(item)}
                  >
                    {item.label}
                  </button>
                ))}
              </div>
            </div>
          ))}
        </div>
      )}

      <div className='cam-bar'>
        <button
          className={`cam-btn ${showWardrobe ? 'active' : ''}`}
          onClick={() => setShowWardrobe(s => !s)}
          title='20 Karakter Arasından Seçim Yap (Kısayol: C)'
        >
          👕 Karakter ({AVATAR_ROSTER.length})
        </button>
        <button
          className={`cam-btn ${camMode === 'walk' ? 'active' : ''}`}
          onClick={() => applyCamMode('walk')}
          title='Sokak Görünümü (Kısayol: V)'
        >
          👤 Sokak
        </button>
        <button
          className={`cam-btn ${camMode === 'fly' ? 'active' : ''}`}
          onClick={() => applyCamMode('fly')}
          title='Uçan Kamera / Drone (Kısayol: V)'
        >
          🦅 Uçan Kamera
        </button>
        <button
          className={`cam-btn ${camMode === 'plaza' ? 'active' : ''}`}
          onClick={() => applyCamMode('plaza')}
          title='Ev ve Kiosk Meydanı Tepe Görünümü'
        >
          🏠 Meydan Tepe
        </button>
        <button
          className={`cam-btn ${camMode === 'fullmap' ? 'active' : ''}`}
          onClick={() => applyCamMode('fullmap')}
          title='Tüm Arabahmet + Abdi Çavuş Haritası Tepe Görünümü'
        >
          🛰️ Tüm Harita
        </button>
      </div>

      {/* Host only (stored admin rank): removes every visitor, keeps admins. Two clicks to confirm. */}
      {isHost && (
        <button
          className={`kick-btn ${kickArmed ? 'armed' : ''}`}
          onClick={kickAllVisitors}
          title='Adminler dışındaki herkesi dünyadan çıkarır'
        >
          {kickArmed ? '⚠️ Emin misiniz? Tekrar tıklayın' : '⛔ Ziyaretçileri Çıkar'}
        </button>
      )}
      </div>
    </div>
  )
}
